import DOMPurify from "dompurify";
import js_beautify from "js-beautify";

export function sanitizeHTML(content) {
  return DOMPurify.sanitize(content, { WHOLE_DOCUMENT: true });
}

const beautifyOptions = {
  indent_size: 2,
  indent_char: " ",
  max_preserve_newlines: 1,
  preserve_newlines: true,
  indent_inner_html: true,
  end_with_newline: true,
  wrap_line_length: 80,
  wrap_attributes: "force-expand-multiline",
  unformatted: ["pre", "code", "textarea"],
  content_unformatted: ["pre", "textarea"],
  inline: [],
  extra_liners: [],
  brace_style: "expand",
};

export function formatHTML(content) {
  const initial = js_beautify.html(content, beautifyOptions);

  const prettierHTML = initial.replace(
    /<([^>]+)>([^<]*)<\/([^>]+)>/g,
    (match, openTag, content, closeTag) => {
      const trimmedContent = content.trim();
      const totalLength = match.length;

      // If total content (including tags) is <= 50 characters, keep inline
      if (totalLength <= 50 && trimmedContent.length > 0) {
        return `<${openTag}>${trimmedContent}</${closeTag}>`;
      }

      // If longer than 50 characters, format on separate lines
      if (trimmedContent.length > 0) {
        // Get current indentation level
        const lines = initial
          .substring(0, initial.indexOf(match))
          .split("\n");
        const currentLine = lines[lines.length - 1];
        const indentMatch = currentLine.match(/^(\s*)/);
        const currentIndent = indentMatch ? indentMatch[1] : "";
        const contentIndent = currentIndent + "  ";

        return `<${openTag}>\n${contentIndent}${trimmedContent}\n${currentIndent}</${closeTag}>`;
      }

      // Empty content, keep as is
      return match;
    }
  );

  return prettierHTML;
}

export function sanitizeAndFormatHTML(content) {
    const sanitizedHTML = sanitizeHTML(content);
    return formatHTML(sanitizedHTML);
}
